import { LayoutLoading } from "components"
import Login from "containers/default/views/Login"
import { useFirebaseAuthContext } from "./firebase-auth-contex"

const RequireFirebaseAuthenticatedUser: React.FC = ({ children }) => {
  const authContext = useFirebaseAuthContext()

  if (!authContext.authReady) {
    return <LayoutLoading withWrapper />
  }

  if (authContext.user === undefined) {
    return <Login />
  }

  return <>{children}</>
}

export default RequireFirebaseAuthenticatedUser
